"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../common/helpers/time");
var StudentWaitlistController = /** @class */ (function () {
    function StudentWaitlistController($window, UserService, WaitListModel, FlashService, sessionTypes, courseTypes) {
        this.$window = $window;
        this.student = UserService.getCurrentUser();
        this.WaitListModel = WaitListModel;
        this.FlashService = FlashService;
        this.sessionTypes = sessionTypes;
        this.courseTypes = courseTypes;
        this.loading = true;
        this.waitListEntries = [];
        this.totalItems = 0;
        this.currentPage = 1;
        this.perPage = 15;
        this.showAddForm = false;
        this.waitListableType = "";
        this.waitListableId = null;
        this.availableTypes = [];
        this.desiredDate = "";
        this.desiredTime = "";
        this.durationHours = 0;
        this.durationMinutes = 0;
        this.submitting = false;
        this.updateDesiredDate = this.updateDesiredDate.bind(this);
        this.updateDesiredTime = this.updateDesiredTime.bind(this);
        this.loadEntries();
    }
    StudentWaitlistController.prototype.loadEntries = function () {
        var _this = this;
        this.loading = true;
        this.WaitListModel.getWaitLists({
            page: this.currentPage,
            user_id: this.student.id,
        })
            .then(function (response) {
            _this.waitListEntries = response.waitLists.data;
            _this.currentPage = response.waitLists.current_page;
            _this.totalItems = response.waitLists.total;
            _this.loading = false;
        })
            .catch(function () {
            _this.waitListEntries = [];
            _this.loading = false;
        });
    };
    StudentWaitlistController.prototype.pageChanged = function () {
        this.loadEntries();
    };
    StudentWaitlistController.prototype.toggleAddForm = function () {
        this.showAddForm = !this.showAddForm;
        if (!this.showAddForm) {
            this.resetForm();
        }
    };
    StudentWaitlistController.prototype.resetForm = function () {
        this.waitListableType = "";
        this.waitListableId = null;
        this.availableTypes = [];
        this.desiredDate = "";
        this.desiredTime = "";
        this.durationHours = 0;
        this.durationMinutes = 0;
        this.submitting = false;
    };
    StudentWaitlistController.prototype.onTypeChange = function () {
        this.waitListableId = null;
        if (this.waitListableType === "session_type") {
            this.availableTypes = this.sessionTypes;
        }
        else if (this.waitListableType === "course_type") {
            this.availableTypes = this.courseTypes;
        }
        else {
            this.availableTypes = [];
        }
    };
    StudentWaitlistController.prototype.updateDesiredDate = function (event) {
        this.desiredDate = event.selected[0] || "";
    };
    StudentWaitlistController.prototype.updateDesiredTime = function (event) {
        this.desiredTime = event.selected[0] || "";
    };
    StudentWaitlistController.prototype.getTotalMinutes = function () {
        return this.durationHours * 60 + this.durationMinutes;
    };
    StudentWaitlistController.prototype.addEntry = function () {
        var _this = this;
        var totalMinutes = this.getTotalMinutes();
        if (!this.waitListableType ||
            !this.waitListableId ||
            !this.desiredDate ||
            !this.desiredTime ||
            !totalMinutes) {
            return;
        }
        this.submitting = true;
        this.FlashService.clearFlash();
        var datePart = (0, time_1.formatDateTime)(this.desiredDate, "YYYY-MM-DD");
        var timePart = (0, time_1.formatDateTime)(this.desiredTime, "HH:mm:ss");
        var request = {
            wait_listable_type: this.waitListableType,
            wait_listable_id: Number(this.waitListableId),
            minutes: totalMinutes,
            user_id: this.student.id,
            desired_at: datePart + " " + timePart,
        };
        this.WaitListModel.create(request)
            .then(function () {
            _this.FlashService.setMessage({
                type: "success",
                message: "Added to waitlist.",
            });
            _this.resetForm();
            _this.showAddForm = false;
            _this.loadEntries();
        })
            .catch(function (error) {
            _this.submitting = false;
            if (error.status === 409) {
                _this.FlashService.setMessage({
                    type: "warning",
                    message: error.data.message,
                });
            }
            else {
                _this.FlashService.setMessage({
                    type: "error",
                    message: error.data.detail || "An error occurred.",
                });
            }
        });
    };
    StudentWaitlistController.prototype.removeEntry = function (entry) {
        var _this = this;
        if (!this.$window.confirm("Are you sure you want to remove this waitlist entry?")) {
            return;
        }
        this.WaitListModel.destroy(entry.id)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.waitListEntries = _this.waitListEntries.filter(function (e) { return e.id !== entry.id; });
        })
            .catch(function () {
            _this.FlashService.setMessage({
                type: "error",
                message: "An error occurred while removing the entry.",
            });
        });
    };
    StudentWaitlistController.prototype.formatType = function (entry) {
        if (entry.wait_listable_type.indexOf("SessionType") !== -1) {
            return "Session Type";
        }
        if (entry.wait_listable_type.indexOf("CourseType") !== -1) {
            return "Course Type";
        }
        return entry.wait_listable_type;
    };
    StudentWaitlistController.prototype.formatDuration = function (minutes) {
        return (0, time_1.formatDuration)(minutes);
    };
    return StudentWaitlistController;
}());
StudentWaitlistController.$inject = [
    "$window",
    "UserService",
    "WaitListModel",
    "FlashService",
    "sessionTypes",
    "courseTypes",
];
exports.default = StudentWaitlistController;
